import {
  Map as ImmutableMap,
} from 'immutable'

function generateDefaultInitialCmsComponentsState() {
  return {
    cmsComponentsMap: ImmutableMap(),
    isLoading: false
  }
}

function cmsComponentReducer(
  state = generateDefaultInitialCmsComponentsState(),
  action) {
  let newState;

  switch (action.type) {
    case 'GET_CMS_COMPONENT': {
      newState = {
        ...state,
        isLoading: true
      };
      break;
    }
    case 'GET_CMS_COMPONENT_FULFILLED': {
      const responseData = action.payload.response;
      newState = {
        ...state,
        isLoading: false,
        cmsComponentsMap: responseData.reduce((total, current) => {
          if (current?.result) {
            return total.set(current?.result?.id?.toString?.(), current.result);
          }
          return total;
        }, state.cmsComponentsMap),
      };
      break;
    }

    case 'GET_DELIVERY_TOOLTIP_FULFILLED': {
      const responseData = action.payload.response;
      newState = {
        ...state
      };
      break;
    }

    case 'LEAVE_HOME_PAGE_ROUTE':
    case 'LEAVE_CATEGORY_PAGE_ROUTE':
    case 'LEAVE_PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU_ROUTE':
    case 'LEAVE_PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID_ROUTE':
    case 'LEAVE_DYNAMIC_PAGE_ROUTE':
    case 'LEAVE_TAG_PAGE_ROUTE': {
      newState = {
        ...state,
        isLoading: false,
        cmsComponentsMap: ImmutableMap(),
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default cmsComponentReducer;
export {
  generateDefaultInitialCmsComponentsState,
};
